var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRulerAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22V18.5C11.25 18.0858 11.5858 17.75 12 17.75C12.4142 17.75 12.75 18.0858 12.75 18.5V22H15.25V20C15.25 19.5858 15.5858 19.25 16 19.25C16.4142 19.25 16.75 19.5858 16.75 20V22H19.25V18.5C19.25 18.0858 19.5858 17.75 20 17.75C20.4142 17.75 20.75 18.0858 20.75 18.5V22H21.0572C21.5779 22 22 21.5247 22 20.9384V15.0616C22 14.4753 21.5779 14 21.0572 14H10V2.94281C10 2.42211 9.52469 2 8.93836 2H3.06164C2.47531 2 2 2.42211 2 2.94281V3.25H5.5C5.91421 3.25 6.25 3.58579 6.25 4C6.25 4.41421 5.91421 4.75 5.5 4.75H2V7.25H4C4.41421 7.25 4.75 7.58579 4.75 8C4.75 8.41421 4.41421 8.75 4 8.75H2V11.25H5.5C5.91421 11.25 6.25 11.5858 6.25 12C6.25 12.4142 5.91421 12.75 5.5 12.75H2V21.0572C2 21.3092 2.11135 21.5381 2.29273 21.7073C2.46188 21.8887 2.6908 22 2.94281 22H11.25ZM7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerAlt1);
export default __webpack_public_path__ + "static/media/ruler-alt-1.e407a9507bd1a508b1a5f06b5f10ffa3.svg";
export { ForwardRef as ReactComponent };